/* eslint-disable no-console */
import './FormSafeCall.scss';

import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

const FormSafeCall = ({ title, text }) => {
    const inputRefs = Array.from({ length: 6 }, () => useRef(null));
    const [digitsArray, setDigitsArray] = useState(Array(6).fill('')); 
    const [iframeUrl, setIframeUrl] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);

    useEffect(() => {
        if (digitsArray.length === 6 && (digitsArray.every(value => value !== ''))) {
            const timer = setTimeout(setFormSubmitted(true), 1200);
            return () => clearTimeout(timer);
        }        
    }, [digitsArray]);

    useEffect(() => {
        if(formSubmitted) {
            const inputDigits = digitsArray.join('');
            const url = `https://identifiering.sakrasamtal.nu/${inputDigits}/v1?s=s&embedded`;
            setIframeUrl(url);
        }
    }, [formSubmitted]); 


    const handleClick = () => {
        setIframeUrl('');
        setDigitsArray(Array(6).fill(''));
        setFormSubmitted(false);
    };

    const handleChange = (e, index) => {
        const { value } = e.target;
        
        if (value < 10 && value >= 0) {
            const updatedDigitsArray = [...digitsArray];
            updatedDigitsArray[index] = value;
            
            setDigitsArray(updatedDigitsArray);

            if (index < inputRefs.length - 1) {
                inputRefs[index + 1].current.focus();
            }
        }
    };

    return (
        <section className="FormSafeCall__Wrapper">
            {!iframeUrl && (
                <form
                    className={classNames('FormSafeCall')}
                    aria-labelledby="formTitle"
                >
                    <div className="FormSafeCall__Container">
                        <h2 id="formTitle" className="FormSafeCall__Title">{title}</h2>
                        <div className="FormSafeCall__Content">
                            <fieldset className="FormSafeCall__InputFields">
                                {inputRefs.map((item, index) => (
                                    <div className="FormSafeCall__Input" key={index}>
                                        <label>
                                            <span className="sr-only">
                                                Mata in en siffra i varje fält för att verifiera mot tjänsten Säkra Samtal.
                                            </span>
                                            <input
                                                className="FormSafeCall__Number"
                                                type="number"
                                                value={digitsArray[index]}
                                                min="0"
                                                max="10"
                                                onChange={(e) => handleChange(e, index)}
                                                ref={item}
                                            />
                                        </label>
                                    </div>
                                ))}
                            </fieldset>
                        </div>
                        <p className="FormSafeCall__Text">{text}</p>
                    </div>
                </form>
            )}
            {iframeUrl && formSubmitted && (
                <>
                    <iframe
                        className="FormSafeCall__Iframe"
                        title="Iframe Säkra Samtal, verifiera din identitet"
                        src={iframeUrl}
                        width="100%"
                        height="auto"
                    />
                    <div className="FormSafeCall__ButtonContainer">
                        <button
                            className="FormSafeCall__Button"
                            onClick={handleClick}
                        >Gör om identifieringen
                        </button>
                    </div>
                </>
            )}
        </section>
    );
};

FormSafeCall.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export default FormSafeCall;
